import {
  BaseFieldMappingFieldProps,
  ExtendedFieldMappingEditorValue,
  FieldMappingData,
  transformSimpleValueOutput,
} from '@components/text-editors/addons/field-mapping';
import { NodeStyledFieldMappingTextEditor } from '@components/text-editors/field-mapping-text-editor';
import { useScopedTranslate } from '@locale/translate';

import { Phone, tag, transformInput } from './extensions';

export type FieldMappingPhoneListFieldProps = BaseFieldMappingFieldProps<
  ExtendedFieldMappingEditorValue[]
> &
  FieldMappingData & { fieldMapText?: { title: string; description: string } };

export const FieldMappingPhoneListField = ({
  defaultValue,
  onChange,
  extensions = [],
  fieldMapText,
  ...rest
}: FieldMappingPhoneListFieldProps) => {
  const { t } = useScopedTranslate(locale);

  return (
    <NodeStyledFieldMappingTextEditor
      extensions={[Phone, ...extensions]}
      plaintext
      singleLine
      onChange={(value) => onChange?.(transformSimpleValueOutput(value, tag))}
      defaultValue={defaultValue ? transformInput(defaultValue) : undefined}
      placeholder={t('placeholder')}
      fieldType="phone"
      disabled
      shouldShowFieldMappingOnFocus
      {...rest}
    />
  );
};

const locale = {
  en: {
    fieldMap: 'Field map',
    fieldMapDescription: 'Receive value from a field in journey',
    phoneLabel: 'Telephone number',
    placeholder: 'Select or add',
    addNumber: 'Add number',
    manuallyAddANumber: 'Manually add a telephone number',
    add: 'Add',
  },
  is: {
    fieldMap: 'Ráðningargögn',
    fieldMapDescription: 'Nota gildi frá reit í ferli',
    phoneLabel: 'Símanúmer',
    placeholder: 'Velja eða bæta við',
    addNumber: 'Nýtt númer',
    manuallyAddANumber: 'Skrá númer handvirkt',
    add: 'Bæta við',
  },
};
